export default __webpack_public_path__ + "static/media/exclamation-triangle.d0ff5bd2.svg";